import { generateUtilityClass, generateUtilityClasses } from '../styles/classes';
export var radioComponentName = 'QuantumRadio';
export function getRadioUtilityClass(slot) {
    return generateUtilityClass(radioComponentName, slot);
}
export var radioClasses = generateUtilityClasses(radioComponentName, [
    'radio',
    'formControlLabel',
    'iconUnchecked',
    'iconChecked',
]);
